export default {
	name: "ButtonBlock",
	data() {
		return {
			isOpen: false,
			language: this.$route.params.lang
		}
	},
	props: [
		"item",
		"index",
		"black"
	],
	created() {},
	watch: {
		"$route": function() {
			this.language = this.$route.params.lang
		}
	},
	computed: {},
	methods: {
		toggleObject() {
			this.isOpen = !this.isOpen
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/blocks/card/card.block.js